// extracted by mini-css-extract-plugin
module.exports = {"dropzone":"attachments-field_dropzone__1Sgca","submitBtn":"attachments-field_submitBtn__3J6OC","deleteBtn":"attachments-field_deleteBtn__3_tMh"};